'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _uiTranslations = require('@wh/ui-translations');

var _messageBus = require('@wh/message-bus');

var _events = require('../../events');

var _components = require('../../components');

var _selectors = require('../../selectors');

/**
 * Maps the state to properties
 * @param {StateType} state The state map
 * @param {Object} props the container properties
 * @returns {Object} The properties to be passed to the Consent component
 */
var mapStateToProps = function mapStateToProps(state) {
  return {
    link: (0, _selectors.configConsentLinkSelector)(state),
    showConsent: (0, _selectors.shouldShowConsentSelector)(state),
    onConsentClick: function onConsentClick() {
      return (0, _messageBus.publish)(_events.MESSAGE_PUB_QD_CONSENT_CLICK);
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _uiTranslations.withTranslator)(_components.Consent));